import Link from './Link'

export * from './Link'

export default Link
